"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApButtonGroup = void 0;
var React = require("react");
var styles_1 = require("./styles");
exports.ApButtonGroup = function (_a) {
    var alignItems = _a.alignItems, className = _a.className, flexDirection = _a.flexDirection, justifyContent = _a.justifyContent, spacingSize = _a.spacingSize, children = _a.children;
    return (React.createElement(styles_1.StyledButtonGroup, { className: "ap-button-group " + (className ? className : ''), alignItems: alignItems, flexDirection: flexDirection, justifyContent: justifyContent, spacingSize: spacingSize }, children));
};
exports.ApButtonGroup.defaultProps = {
    flexDirection: 'row',
    justifyContent: 'initial',
    spacingSize: 'lg'
};
//# sourceMappingURL=ApButtonGroup.js.map